import { CLIENTS_SKELETON_ROWS } from '../../../../../../shared/constants/clients';

import './ClientsTableSkeleton.scss';

interface IClientsTableSkeletonProps {
  columnCount: number;
}

const ClientsTableSkeleton = ({ columnCount }: IClientsTableSkeletonProps) => (
  <div className="clients-skeleton" aria-hidden="true">
    {Array.from({ length: CLIENTS_SKELETON_ROWS }, (_, rowIndex) => (
      <div
        key={rowIndex}
        className="clients-skeleton__row"
        style={{ gridTemplateColumns: `repeat(${columnCount}, 1fr)` }}
      >
        {Array.from({ length: columnCount }, (_, cellIndex) => (
          <span key={cellIndex} className="clients-skeleton__bar" />
        ))}
      </div>
    ))}
  </div>
);

export default ClientsTableSkeleton;
